import React, {useEffect} from 'react';
import {Flex, Popover, Tabs} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import JournalPage from "./Journal/JournalPage";
import {LocalName} from "../../../../utils/LocalName";
import {getGroup, getJournal} from "../../../../store/slices/TeacherGroupSlice";
import {LeftOutlined} from "@ant-design/icons";
import GradesPage from "./Grade/GradesPage";
import BlockLoading from "../../../../components/LoadingComponents/BlockLoading";
import GroupCertificatesButton from "./GroupCertificatesButton";
import GroupExportButton from "./GroupExportButton";

const TeacherGroupPage = () => {
    const {id} = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {group, journal, isLoading} = useSelector(state => state.teacherGroup);

    // useEffect(() => {
    //     setLoading(true);
    //     handleFetchData();
    // }, []);

    useEffect(() => {
        // dispatch(getGroup({id}));
        dispatch(getJournal({id}));
    }, []);

    const onChangeTabs = async (key) => {
        if (key === '1') {

        }
    };

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'journal'}/>,
            children: <JournalPage/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'tg.grades'}/>,
            children: <GradesPage/>,
        },
        // {
        //     key: '5',
        //     label: <IntlMessage id={'tests'}/>,
        //     children: <TestsListPage/>,
        // },
    ]

    // async function handleFetchData() {
    //     setLoading(true);
    //     await GroupService.getGroup(id)
    //         .then((r) => {
    //             setGroup(r.data);
    //         })
    //         .catch(() => {
    //             message.destroy();
    //             message.error(<IntlMessage id={'error'}/>, 5);
    //         })
    //         .finally(() => {
    //             setLoading(false);
    //         })
    // }


    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <BlockLoading isLoading={isLoading}/>
            <Flex gap={"middle"} align={"center"} justify={"space-between"} style={{width: "100%"}} wrap={"wrap"}>
                <Flex gap={"middle"} align={"center"}>
                    <LeftOutlined style={{cursor: "pointer"}} onClick={() => navigate("/p/groups")}/>
                    <MyText uppercase strong size={"large"}>{LocalName.getName(journal.group) + " " + journal?.group?.number}</MyText>
                </Flex>
                {/* две кнопки в своей обёртке с wrap — на узких экранах они иначе уезжают за заголовок */}
                <Flex gap={"middle"} align={"center"} wrap={"wrap"}>
                    <GroupCertificatesButton groupId={journal?.group?.id}/>
                    <GroupExportButton groupId={journal?.group?.id}
                                       groupTitle={LocalName.getName(journal.group) + " " + journal?.group?.number}/>
                </Flex>
            </Flex>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems} onChange={onChangeTabs}/>
        </Flex>
    );
};

export default TeacherGroupPage;